import { IntakeCompletionStatuses } from '@common/models/Enums';
import { IModel, Model, ModelRecord } from '@common/models/Model';

export interface IVisitIntakeCompletionStatus extends IModel {
  intakeCompletionStatusId: IntakeCompletionStatuses;
  name: string;
}

export class VisitIntakeCompletionStatusModel
  extends Model
  implements ModelRecord<IVisitIntakeCompletionStatus>
{
  intakeCompletionStatusId: IntakeCompletionStatuses;
  name: string;
  constructor(params: Partial<IVisitIntakeCompletionStatus>) {
    super(params);
    this.intakeCompletionStatusId = _.defaultTo(
      params.intakeCompletionStatusId,
      0 as IntakeCompletionStatuses,
    );
    this.name = _.defaultTo(params.name, '');
  }
}
